<template>
  <div class="range-slider">
    <div class="uk-flex uk-flex-between">
      <div class="uk-margin-medium-right uk-visible@m">
        <small>{{ minLabel }}</small>
      </div>
      <div class="uk-width-expand">
        <input type="range" class="uk-range"
               :min="min"
               :max="max"
               :step="step"
               ref="slider"
               v-model="rangeSliderValue"
        />
        <output class="range-slider-output" ref="outputElement">
          <span>
            {{ rangeSliderValue }}
            <small v-if="outputSuffix.length > 0">{{ outputSuffix }}</small>
          </span>
        </output>
      </div>
      <div class="uk-margin-medium-left uk-visible@m">
        <small>{{ maxLabel }}</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RangeSlider.vue',
  props: {
    min: {
      type: [String, Number],
      default: '0',
    },
    max: {
      type: [String, Number],
      default: '100',
    },
    step: {
      type: [String, Number],
      default: '1',
    },
    maxLabel: {
      type: String,
      required: false,
    },
    minLabel: {
      type: String,
      required: false,
    },
    defaultValue: {
      type: [String, Number],
      default: '0',
    },
    outputSuffix: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      value: this.defaultValue,
    };
  },
  mounted() {
    this.rangeSliderValue = this.defaultValue;
  },
  computed: {
    rangeSliderValue: {
      get() {
        return this.value || this.defaultValue;
      },
      set(value) {
        const val = Number(value);
        const min = Number(this.min ? this.min : 0);
        const max = Number(this.max ? this.max : 100);
        const newVal = Number(((val - min) * 100) / (max - min));

        // Sorta magic numbers based on size of the native UI thumb
        this.$refs.outputElement.style.marginLeft = `calc(${newVal}% + (${2 - newVal * 0.35}px))`;
        this.value = value;

        this.$emit('change', value);
      },
    },
  },
};
</script>
